export const KEY_PRESS = {
    ENTER: 13
}
